import React from 'react';
import View from './View';


const bottomNav = (props: any) => <View {...props} />;

export default bottomNav;
